// Port of api/fuel/app/classes/filter/search/games/sorts/query/collection/added.php
import { sorted, sortReverse, sortPriority } from 'offline/filter/core/search/unit'
export default {
	name: 'collection.added',
	post: false,
	require: function(config, filter) { return sorted('collection.added', filter) > 0 },
	run: function(config, filter, data, query) {
		query.order('c.collection_date_owned', sortReverse('collection.added', filter), sortPriority('collection.added', filter))
	}
}
